import '.a{display:grid;}.ssr-plugin'
import '.c{gap:1.5rem;}.ssr-plugin'
import { usePopularHousingForms } from './usePopularHousingForms'
import { HousingFormCard } from '@app/components/blocks/card/HousingFormCard'
import defaultHousingFormPicture from '@app/assets/defaultHousingFormPicture.png'
import { pages } from '@app/util/links'
import { styled } from 'inlines'
import useMediaQuery from '@app/util/useMediaQuery'
import { ViewHousingFormModel } from 'functions/app/housing-form/view'

const HousingFormCardItem = ({
  housingForm,
  to,
}: {
  housingForm: ViewHousingFormModel & { followerCount: number }
  to: string
}) => {
  return (
    <HousingFormCard
      image={housingForm.images?.[0] ?? defaultHousingFormPicture}
      title={housingForm.title}
      followers={housingForm.followers ?? []}
      followerCount={housingForm.followerCount}
      to={to}
    />
  )
}

export const HousingFormPagePopularHousingForms = ({
  excludeIds,
}: {
  excludeIds: (string | number)[]
}) => {
  const isMobile = useMediaQuery()
  const { popularHousingForms } = usePopularHousingForms({ excludeIds })

  return (
    <div className="a c"
      style={{
        gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
      }}
    >
      {popularHousingForms.map((housingForm) => (
        <HousingFormCardItem
          key={housingForm.id}
          housingForm={housingForm}
          to={pages.housingForm(housingForm.slug)}
        />
      ))}
    </div>
  )
}
